import React from 'react';
import './loader.scss';
import { CircularProgress } from '@mui/material';

const Loading = props => {
  const { isLoading } = props;
  return (
    <>
      {isLoading ? (
        <>
          {!props?.noFade && <div className="loader"></div>}
          {/* <div className="overlay">
            <CircularProgress />
          </div> */}
          <div className="centered-justified" style={{ color: '#3D2470' }}>
            <span
              className="spinner-border spinner-border-m"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Loading;
